import { gql } from "@apollo/client";

export const MUTATION_INSERT_SIGN_INFORMED_CONSENT = gql`
  mutation MUTATION_INSERT_SIGN_INFORMED_CONSENT(
    $signInformedConsent: [signInformedConsent_insert_input!]!
  ) {
    insert_signInformedConsent(objects: $signInformedConsent) {
      returning {
        userId
        phone
        name
        id
        signature
        documentType
        documentNumber
        doctorId
        created_at
        countryPhone
      }
    }
  }
`;
